const safeParse = (value) => {
  try {
    return value ? JSON.parse(value) : {};
  } catch {
    return {};
  }
};

const normalize = (value) => String(value || '').trim();
const normalizeLower = (value) => normalize(value).toLowerCase();

export const getCurrentTransferAgentIdentity = () => {
  const user = safeParse(localStorage.getItem('user'));
  const extensionData = safeParse(localStorage.getItem('extension'));

  return {
    extension: normalize(
      extensionData?.extensionNumber ||
      extensionData?.sipUsername ||
      user?.ExtensionNumber ||
      user?.extensionNumber
    ),
    loginName: normalize(user?.LoginName || user?.loginName || user?.username),
    fullName: normalize(user?.FullName || user?.fullName || user?.displayName),
    userId: normalize(user?.UserID || user?.userId)
  };
};

export const buildTransferAgentQuery = () => {
  const identity = getCurrentTransferAgentIdentity();
  const params = new URLSearchParams();

  if (identity.extension) params.set('excludeExtension', identity.extension);
  if (identity.loginName) params.set('excludeLoginName', identity.loginName);
  if (identity.fullName) params.set('excludeFullName', identity.fullName);
  if (identity.userId) params.set('excludeUserId', identity.userId);

  const query = params.toString();
  return query ? `?${query}` : '';
};

export const excludeCurrentAgentEntries = (agents = []) => {
  const identity = getCurrentTransferAgentIdentity();
  return agents.filter((agent) => {
    const sameExtension = identity.extension && normalize(agent?.extension) === identity.extension;
    const sameLoginName =
      identity.loginName &&
      normalizeLower(agent?.username || agent?.loginName) === normalizeLower(identity.loginName);
    const sameFullName =
      identity.fullName &&
      normalizeLower(agent?.displayName || agent?.fullName) === normalizeLower(identity.fullName);
    const sameUserId = identity.userId && normalize(agent?.cmsUserId || agent?.userId) === identity.userId;

    return !(sameExtension || sameLoginName || sameFullName || sameUserId);
  });
};
